export const authSelector = ({ auth }) => auth

export const userSelector = ({ auth: { user } }) => user

export const tokenSelector = ({ auth: { token } }) => token
